import * as React from "react";
import { EmptyState as BaseEmptyState } from "@/components/ui/empty-state";
import { FileX, LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon = FileX,
  title,
  description,
  className = ''
}) => {
  return (
    <BaseEmptyState
      icon={icon}
      title={title}
      description={description}
      variant="default"
      className={className}
    />
  );
};

export default EmptyState;
